export const PIN_CHANGE = 'changepin';

export const FORM_FIELDS = {
    CURRENT_PIN: 'currentPin',
    NEW_PIN: 'newAuthenticationPhonePin',
    VERIFY_PIN: 'verifyPin'
};
